@if (!isCvvValid) {
    <nz-result
        nzStatus="error"
        nzTitle="Invalid breakdown link"
        nzSubTitle="The link is invalid or has been changed. Please request a new link."
    ></nz-result>
}
@else {
    <div class="fbl-header">
        <div class="header-title-row">
            <div>
                <h1>Your breakdowns</h1>
                <span>Current and recent incidents</span>
            </div>
            @if (returnContext) {
                <button nz-button nzType="text" nzSize="large" class="new-breakdown-link" (click)="returnToNewBreakdown()">
                    <nz-icon nzType="plus-circle" nzTheme="outline" />
                    Log breakdown
                </button>
            }
        </div>
    </div>

    <main class="mobile-container">
        <nz-spin [nzSpinning]="isLoading">
            @if (loadFailed) {
                <nz-result
                    nzStatus="error"
                    nzTitle="Unable to load breakdowns"
                    nzSubTitle="Please try opening the link again."
                ></nz-result>
            }
            @else if (!isLoading && incidents.length === 0) {
                <nz-result
                    nzStatus="info"
                    nzTitle="No breakdowns found"
                    nzSubTitle="Your fleet has no incidents to display."
                ></nz-result>
            }
            @else {
                <div class="incident-list">
                    @for (incident of incidents; track incident.incidentId) {
                        <article class="incident-card">
                            <div class="card-header">
                                <div>
                                    <span class="card-label">Breakdown</span>
                                    <h2>
                                        #{{ incident.incidentNumber || incident.incidentId }}
                                        @if (incident.orderNumber) {
                                            <span class="order-number">/ {{ incident.orderNumber }}</span>
                                        }
                                    </h2>
                                </div>
                                @if (incident.statusId >= 10) {
                                    <nz-tag nzColor="blue">{{ incident.status }}</nz-tag>
                                } @else {
                                    @let state = getIncidentCurrentState(incident);
                                    <div class="next-status-col">
                                        @if (state === null) {
                                            <span class="state-label state-completed">
                                                <nz-icon nzType="check-circle" nzTheme="outline"></nz-icon> Completed
                                            </span>
                                        } @else {
                                            <div [class]="'state-label ' + (state.severity === 'critical' ? 'state-critical' : state.severity === 'warn' ? 'state-warn' : '')">
                                                @if (state.severity !== 'normal') {
                                                    <nz-icon nzType="warning" nzTheme="fill"></nz-icon>
                                                }
                                                {{ state.awaitingLabel }}
                                            </div>
                                            <div class="state-time">
                                                @if (state.etaMinutesRemaining !== undefined) {
                                                    @if (state.etaMinutesRemaining >= 0) {
                                                        <span class="state-elapsed">({{ state.etaMinutesRemaining }} min remaining)</span>
                                                    } @else {
                                                        <span [class]="'state-elapsed ' + (state.severity === 'critical' ? 'state-critical' : 'state-warn')">({{ -state.etaMinutesRemaining }} min overdue)</span>
                                                    }
                                                } @else {
                                                    <span class="state-elapsed">({{ state.minutesElapsed }} min ago)</span>
                                                }
                                            </div>
                                        }
                                    </div>
                                }
                            </div>

                            @if (incident.location && incident.location.description) {
                                <div class="card-row">
                                    <nz-icon nzType="environment" nzTheme="outline" />
                                    <span>{{ incident.location.description }}</span>
                                </div>
                            }

                            @if (incident.fleetVehicle && incident.fleetVehicle.registrationNumber) {
                                <div class="card-row">
                                    <nz-icon nzType="car" nzTheme="outline" />
                                    <span>{{ incident.fleetVehicle.registrationNumber }}</span>
                                </div>
                            }

                            @if (incident.transporterName) {
                                <div class="card-row">
                                    <nz-icon nzType="shop" nzTheme="outline" />
                                    <span><strong>Transporter:</strong> {{ incident.transporterName }}</span>
                                </div>
                            }

                            @if (incident.driver && (incident.driver.name || incident.driver.phoneNumber)) {
                                <div class="card-row">
                                    <nz-icon nzType="user" nzTheme="outline" />
                                    <span>
                                        <strong>Driver:</strong> {{ incident.driver.name || 'Not provided' }}
                                        @if (incident.driver.phoneNumber) {
                                            <a [href]="'tel:' + incident.driver.phoneNumber">{{ incident.driver.phoneNumber }}</a>
                                        }
                                    </span>
                                </div>
                            }

                            @if (incident.dtLogged) {
                                <div class="card-footer">
                                    Logged {{ incident.dtLogged | date:'d MMM y, HH:mm' }}
                                </div>
                            }

                            <button
                                nz-button
                                nzType="primary"
                                nzBlock
                                class="update-details-button"
                                [routerLink]="['/report-new-breakdown', incident.incidentId]">
                                <nz-icon nzType="form" nzTheme="outline" />
                                Update details
                            </button>
                        </article>
                    }
                </div>
            }
        </nz-spin>
    </main>
}
